// 统一的加载动画组件
import React from 'react';

interface LoadingSpinnerProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  className?: string;
  fullPage?: boolean; // 是否为全页面加载
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  size = 'medium', 
  text = 'Loading...', 
  className = '',
  fullPage = false
}) => {
  const sizeClasses = {
    small: 'w-4 h-4',
    medium: 'w-6 h-6',
    large: 'w-8 h-8'
  };

  // 统一所有文字为 text-sm
  const textClass = 'text-sm';

  const content = (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div 
        className={`${sizeClasses[size]} border-2 border-blue-200 border-t-blue-600 rounded-full animate-spin`}
      ></div>
      {text && (
        <p className={`${textClass} text-gray-600 mt-3`}>
          {text}
        </p>
      )}
    </div>
  );

  // 如果是全页面加载，添加统一的容器样式
  if (fullPage) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;